import { atom, swr } from '@exodus/headless-ui';
import { swapModeAtom, isLoadingAtom, quoteAtom } from './index.js';
const isToLoadingAtom = atom((get) => {
    const isExactIn = get(swapModeAtom) === 'ExactIn';
    const isInitialLoading = get(isLoadingAtom);
    const isLoadingData = isExactIn ? get(swr(quoteAtom)).loading : false;
    return isInitialLoading || isLoadingData;
});
export default isToLoadingAtom;
